angular
  .module('task')

  .factory('TaskCountersCache', function() {
    let cache;

    return {
      get: () => cache,
      set: value => (cache = value)
    };
  });
